import { APP_INITIALIZER, Provider } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * Factory function that registers custom SVG icons with Angular Material's MatIconRegistry.
 * This function is called during app initialization to make custom icons
 * available throughout the application.
 *
 * APP_INITIALIZER expects a factory that returns a function, hence the double arrow function.
 */
export function registerCustomIcons(
  iconRegistry: MatIconRegistry,
  sanitizer: DomSanitizer
): () => void {
  return () => {
    const icons: [string, string][] = [
      ['hivelog-bee', 'assets/icons/hivelog/bee.svg'],
      ['hivelog-beehive', 'assets/icons/hivelog/beehive.svg'],
      ['hivelog-harvest', 'assets/icons/hivelog/harvest.svg'],
      ['hivelog-hive', 'assets/icons/hivelog/hive.svg'],
      ['hivelog-frame', 'assets/icons/hivelog/frame.svg'],
      ['hivelog-cell', 'assets/icons/hivelog/cell.svg'],
      ['hivelog-food', 'assets/icons/hivelog/food.svg'],
      ['hivelog-keeper', 'assets/icons/hivelog/keeper.svg'],
    ];

    icons.forEach(([name, path]) => {
      iconRegistry.addSvgIcon(
        name,
        sanitizer.bypassSecurityTrustResourceUrl(path)
      );
    });
  };
}

/**
 * Provider function for registering custom SVG icons.
 * Add this to your application providers array to make custom icons available.
 *
 * @example
 * // In main.ts or app.config.ts
 * bootstrapApplication(AppComponent, {
 *   providers: [
 *     provideCustomIcons(),
 *     // ... other providers
 *   ]
 * });
 */
export function provideCustomIcons(): Provider {
  return {
    provide: APP_INITIALIZER,
    useFactory: registerCustomIcons,
    deps: [MatIconRegistry, DomSanitizer],
    multi: true
  };
}
